import React from "react";
import { useRouteError } from "react-router-dom";

// Rendered by react-router-dom whenever a route's render throws, a
// loader rejects, or any descendant component throws during render.
// Replaces React Router's built-in dev hint ("Hey developer 👋 …") with
// a user-facing message and a recovery action.
export default function ErrorFallback() {
  const error = useRouteError();

  // eslint-disable-next-line no-console
  console.error("[ErrorBoundary]", error);

  return (
    <div
      role="alert"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        textAlign: "center",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <h1 style={{ fontSize: 28, marginBottom: 12 }}>Something went wrong</h1>
      <p style={{ color: "#666", maxWidth: 520, marginBottom: 24 }}>
        The page hit an unexpected error. The team has been notified — please
        try again in a moment or return to the homepage.
      </p>
      <div style={{ display: "flex", gap: 12 }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 20px",
            border: "1px solid #ccc",
            borderRadius: 4,
            background: "#fff",
            cursor: "pointer",
          }}
        >
          Reload
        </button>
        <button
          onClick={() => {
            window.location.href = "/";
          }}
          style={{
            padding: "10px 20px",
            border: "none",
            borderRadius: 4,
            background: "#7a1620",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Go home
        </button>
      </div>
    </div>
  );
}
